var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8673 20C39.8673 25.3043 40 20 40 40C19.9338 40 25.2205 40 19.9338 40C14.6471 40 19.9339 40 0.00073286 39.8698C-0.00016225 20 0.000284881 25.3043 0.000284881 20C0.000284881 14.6957 0.000275467 20 0 0.130156C19.9337 1.80139e-05 14.6471 0 19.9338 0C25.2205 0 19.9338 0.130173 39.8673 0.130176C39.8673 20 39.8673 14.6957 39.8673 20ZM15.5983 28.3333V15.9667H11.8441V28.3333H15.5983ZM13.7212 14.2667C15.0335 14.2667 15.8474 13.3167 15.8474 12.1333C15.8142 10.9167 15.0169 10 13.7544 10C12.4587 10 11.6282 10.9167 11.6282 12.1333C11.6282 13.3167 12.4421 14.2667 13.7046 14.2667H13.7212ZM21.3956 28.3333H17.2428C17.2428 28.3333 17.3092 17.5 17.2428 16.3833H21.3956V18.0833L21.3624 18.1167H21.3956V18.0833C21.7866 17.4503 22.3395 16.934 22.9968 16.5881C23.6541 16.2422 24.3918 16.0795 25.1331 16.1167C27.8574 16.1167 29.9006 17.8167 29.9006 21.4833V28.3333H25.7477V21.95C25.7477 20.3333 25.1497 19.25 23.6547 19.25C22.5085 19.25 21.8275 19.9833 21.5285 20.7C21.4288 20.95 21.3956 21.3 21.3956 21.6667V28.3333Z",
    fill: "#3E83C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialLinkedin);
export default __webpack_public_path__ + "static/media/social-linkedin.232468c5084295a6a435b8fd0da9e50f.svg";
export { ForwardRef as ReactComponent };